import type {
  SmartSearchResponse,
  SmartSearchResult,
} from '@finance/contracts';
import { apiFetch } from '../../api/http-client';

export type { SmartSearchResult, SmartSearchResponse };

export async function searchOrganizationExperience(
  query: string,
  options: { limit?: number; signal?: AbortSignal } = {},
): Promise<SmartSearchResponse> {
  return apiFetch<SmartSearchResponse>('/api/search/query', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ q: query, limit: options.limit }),
    signal: options.signal,
  });
}

export interface SmartSearchSelectionEvidence {
  resultKind: SmartSearchResult['kind'];
  entityType?: SmartSearchResult['entityType'];
  routeId: string;
  rank: number;
  queryLength: number;
  partial: boolean;
}

export async function recordSmartSearchSelection(
  evidence: SmartSearchSelectionEvidence,
): Promise<void> {
  await apiFetch('/api/search/selection', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(evidence),
  });
}
